import React, { useState, useRef } from 'react';
import { Loader2, ExternalLink } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const DRESSTEK_URL = 'https://dresstek.vercel.app';
const DRESSTEK_ORIGIN = 'https://dresstek.vercel.app';

export default function Dresstek() {
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const iframeRef = useRef(null);

  const handleLoad = () => {
    setLoading(false);
    // Envoie l'email Equibook à DressTek pour la liaison de compte (SSO)
    if (user?.email && iframeRef.current?.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        { type: 'equibook_user', email: user.email },
        DRESSTEK_ORIGIN
      );
    }
  };

  return (
    <div className="flex flex-col h-full">
      {/* Header — couleur fond DressTek, sans titre */}
      <div className="flex items-center justify-end px-4 py-2 shrink-0" style={{ backgroundColor: '#213418' }}>
        <a
          href={DRESSTEK_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 text-xs text-white/50 hover:text-white/90 transition-colors"
        >
          <ExternalLink className="w-3.5 h-3.5" />
          Ouvrir dans un nouvel onglet
        </a>
      </div>

      {/* Iframe plein écran */}
      <div className="relative flex-1 min-h-0">
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-stone-50 z-10">
            <div className="flex flex-col items-center gap-3 text-stone-400">
              <Loader2 className="w-8 h-8 animate-spin" />
              <span className="text-sm">Chargement de Dresstek…</span>
            </div>
          </div>
        )}
        <iframe
          ref={iframeRef}
          src={DRESSTEK_URL}
          title="Dresstek"
          className="w-full h-full border-0"
          onLoad={handleLoad}
          allow="fullscreen"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
        />
      </div>
    </div>
  );
}
